import { Injectable } from '@angular/core';
@Injectable()
export class CustomMapMarker extends google.maps.OverlayView {
  position: google.maps.LatLng;
  private containerDiv: HTMLElement;
  private anchorOffsetX: number;
  private anchorOffsetY: number;
  private timestampContainer: HTMLElement;
  private timestamp: HTMLElement;

  content: HTMLImageElement;

  constructor() {
    super();
  }

  init(position: google.maps.LatLng, imageUrl: string, size?: google.maps.Size, created?: Date, anchorOffsetX?: number, anchorOffsetY?: number) {
    this.position = position;
    this.setContent(imageUrl, size);
    this.setContainerDiv(size);
    if (created) {
      this.addTimeStamp(created);
    }
    this.anchorOffsetX = anchorOffsetX || 0;
    this.anchorOffsetY = anchorOffsetY || 0;
  }

  setContent(imageUrl: string, size?: google.maps.Size) {
    if (this.content) {
      this.content.parentElement.removeChild(this.content);
    }
    this.content = document.createElement('img');
    if (size) {
      this.content.width = size.width;
      this.content.height = size.height;
    }
    this.content.src = imageUrl;
    this.content.classList.add('custom-popup');
    this.content.style.top = -(this.content.height / 2) + 'px';
    this.content.style.left = -(this.content.width / 2) + 'px';
  }

  private setContainerDiv(size?: google.maps.Size) {
    this.containerDiv = document.createElement('div');
    if (size) {
      this.containerDiv.style.width = size.width + 'px';
      this.containerDiv.style.height = size.height + 'px';
    }
    this.containerDiv.classList.add('custom-popup-container');
    this.containerDiv.appendChild(this.content);
    this.containerDiv.style.position = 'relative';
  }

  private addTimeStamp(created: Date) {
    this.timestampContainer = document.createElement('div');
    this.timestampContainer.style.display = 'block';
    this.containerDiv.appendChild(this.timestampContainer);
    this.timestamp = this.createTimestampElement(this.timeSince(created));
    this.timestampContainer.appendChild(this.timestamp);
  }

  private createTimestampElement(innerText: string) {
    const timestamp = document.createElement('div');
    timestamp.innerText = innerText;
    timestamp.style.height = '26px';
    timestamp.style.width = '26px';
    timestamp.style.lineHeight = '24px';
    timestamp.style.background = 'white';
    timestamp.style.border = '1px solid grey';
    timestamp.style.borderRadius = '13px';
    timestamp.style.position = 'absolute';
    timestamp.style.fontSize = '9px';
    timestamp.style.fontWeight = 'bolder';
    timestamp.style.textAlign = 'center';
    timestamp.style.color = '#606060';
    timestamp.style.left = '25px';
    timestamp.style.top = '-11px';
    return timestamp;
  }

  // google.maps.OverlayView

  onAdd() {
    this.getPanes().floatPane.appendChild(this.containerDiv);
  }

  onRemove() {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);
    }
    this.containerDiv.style.display = 'none';
  }

  draw() {
    if (this.getProjection()) {
      var divPosition = this.getProjection().fromLatLngToDivPixel(
        this.position
      );

      // Hide the popup when it is far out of view.
      var display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
          ? 'block'
          : 'none';

      if (display === 'block') {
        this.containerDiv.style.left = (divPosition.x + this.anchorOffsetX) + 'px';
        this.containerDiv.style.top = (divPosition.y + this.anchorOffsetY) + 'px';
      }
      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display;
      }
    }
  }

  // Marker positioning

  private timer: NodeJS.Timer;

  /**
   * @param  {google.maps.LatLng} position
   */
  setPosition(position: google.maps.LatLng) {
    this.timer && clearInterval(this.timer);
    this.position = position;
    this.draw();
  }

  getPosition(): google.maps.LatLng {
    return this.position;
  }

  /**
   * Helper to provide timestamp formatting (example 1 minute in the past -> "1m")
   * Note: this is not currently available via moment.js
   * @param  {Date} date
   */
  private timeSince(date: Date) {
    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      return interval + 'y';
    }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return interval + 'M';
    }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return interval + 'd';
    }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return interval + 'h';
    }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return interval + 'm';
    }
    return Math.floor(seconds) + 's';
  }

}



// WEBPACK FOOTER //
// ./src/providers/map/custom-map-marker.ts